
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { CarCriteria } from '../../car/models/car-criteria.model';
import { Car } from '../../car/models/car.model';
import { AppFunctions } from '../../common/constants/app-functions';
import { AppUrl } from '../../common/constants/app-urls';
import { CarBusinessLine } from '../../car/constants/car-basic-data';
import { TransactionRole, TransactionStage, ObjectClass } from '../../common/constants/common-basic-data';
import { MenuCode } from '../../common/constants/session-basic-data';
import { Message } from '../../common/models/message.model';
import { Price, StringData } from '../../common/models/string-data.model';
import { JobCriteria } from '../../keep/models/job-criteria.model';
import { KeepOffer } from '../../keep/models/keep-offer.model';
import { ReviewStatus } from '../constants/dealer-basic-data';
import { ContractModification } from '../models/contract-modification.model';
import { Contract } from '../models/contract.model';
import { DealerCriteria } from '../models/dealer-criteria.model';
import { Dealer } from '../models/dealer.model';
import { ReviewReply } from '../models/review-reply.model';
import { Review } from '../models/review.model';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class DealerService {
    //loggedIn = false;
  constructor(private http: HttpClient) {}

  getDealerDetails(): Observable<Dealer>{ 
      
    return this.http.get<any>(AppUrl.dealer+"/details/my", httpOptions );

  }

  updateDealerProfile(dlUpdates: Dealer): Observable<any>{ 
   return this.http.post<any>(
      AppUrl.dealer+"/details/update", 
      AppFunctions.removeEmpty(dlUpdates), 
      httpOptions );
  }

  getProviderPublicDetailsById(providerId: string): Observable<any>{

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let params = new HttpParams();
    params = params.append("providerId", providerId);

    console.log("params = " +params)
      
    return this.http.get<any>(AppUrl.dealer+"/provider-public", {headers, params} );
    
  }

  toggleFavoriteProvider(providerId: string, makeFav: boolean): Observable<any>{
      
    let url: string = makeFav ? AppUrl.dealer+"/provider-favorite/add" : AppUrl.dealer+"/provider-favorite/remove";
    
    return this.http.post<any>(
      url, 
      providerId, 
      httpOptions );
    
  }

  getMyProviders(): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    return this.http.get<any>(AppUrl.dealerSearchProviders+"/allmy", {headers} );
    
  }

  getMyOwners(): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    return this.http.get<any>(AppUrl.dealerSearchOwners+"/allmy", {headers} );
    
  }


  createNewCar(carDetails: Car): Observable<Car>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;
    //let credentials: LoginCredentials = new LoginCredentials (username, password); 
    //return this.http.post<any>(AppUrl.carDetails+"/new", {make: car.make, model: car.model, variant: car.variant, bodyType: car.bodyType, firstRegistration: 2021}, httpOptions );
    return this.http.post<Car>(
      AppUrl.carDetails+"/new", 
      AppFunctions.removeEmpty(carDetails), 
      httpOptions );
  }

  // Provider offer

  createNewProviderOffer(providerOffer: Car): Observable<Car>{ 
    console.log(providerOffer)
    return this.http.post<Car>(
      AppUrl.apiBaseURL+"/"+providerOffer.businessLine.toString().toLowerCase()+"/offers/new", 
      AppFunctions.removeEmpty(providerOffer), 
      httpOptions );
  }

  updateProviderOffer(providerOfferUpd: Car): Observable<any>{ 
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/"+providerOfferUpd.businessLine.toString().toLowerCase()+"/offers/update", 
      AppFunctions.removeEmpty(providerOfferUpd), 
      httpOptions );
  }

  updateProviderOfferPostedStatus(providerOfferId: string, businessLine: CarBusinessLine): Observable<any>{ 
    
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/offers/"+providerOfferId+"/toggle-posted", 
      httpOptions );
  }

  updateProviderOfferClosedStatus(providerOfferId: string, businessLine: CarBusinessLine): Observable<any>{ 
    
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/offers/"+providerOfferId+"/toggle-closed", 
      httpOptions );
  }

  deleteProviderOffer(providerOfferId: string, businessLine: CarBusinessLine): Observable<any>{ 
    return this.http.delete<any>(
      AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/offers/"+providerOfferId, 
      httpOptions );
  }

  fetchMyProviderOffers(businessLine: CarBusinessLine, transactionRole: TransactionRole, transactionStages: TransactionStage[]): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let params = new HttpParams();
    params = params.append("transactionStages", transactionStages.join(', '));

    let url: string = "";

    switch(transactionRole){

      case TransactionRole.CUSTOMER : {
        url = AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/offers/for-customer"
        break;
      }

      case TransactionRole.PROVIDER: {
        url = AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/offers/for-provider"
        break;
      }
    }
    //console.log("params = " +params)
      
    return this.http.get<any>(
      url, 
      {headers, params}
    );
  }


    // Keep offer

  createNewKeepOffer(keepOffer: KeepOffer): Observable<KeepOffer>{ 
    console.log(keepOffer)
    return this.http.post<KeepOffer>(
      AppUrl.apiBaseURL+"/"+keepOffer.businessLine.toString().toLowerCase()+"/offers/new", 
      AppFunctions.removeEmpty(keepOffer), 
      httpOptions );
  }

  updateKeepOffer(keepOfferUpd: KeepOffer): Observable<any>{ 
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/"+keepOfferUpd.businessLine.toString().toLowerCase()+"/offers/update", 
      AppFunctions.removeEmpty(keepOfferUpd), 
      httpOptions );
  }

  updateKeepOfferPostedStatus(keepOfferId: string): Observable<any>{ 
    
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/keep/offers/"+keepOfferId+"/toggle-posted", 
      httpOptions );
  }

  updateKeepOfferClosedStatus(keepOfferId: string): Observable<any>{ 
    
    return this.http.post<any>(
      AppUrl.apiBaseURL+"/keep/offers/"+keepOfferId+"/toggle-closed", 
      httpOptions );
  }

  deleteKeepOffer(keepOfferId: string): Observable<any>{ 
    return this.http.delete<any>(
      AppUrl.apiBaseURL+"/keep/offers/"+keepOfferId, 
      httpOptions );
  }

  fetchMyKeepOffers(transactionRole: TransactionRole, transactionStages: TransactionStage[]): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let params = new HttpParams();
    params = params.append("transactionStage", transactionStages.join(', '));

    let url: string = "";

    switch(transactionRole){

      case TransactionRole.CUSTOMER : {
        url = AppUrl.apiBaseURL+"/keep/offers/for-customer"
        break;
      }

      case TransactionRole.PROVIDER: {
        url = AppUrl.apiBaseURL+"/keep/offers/for-provider"
        break;
      }
    }
    //console.log("params = " +params)
      
    return this.http.get<any>(
      url, 
      {headers, params}
    );
  }


  getMyCarsForOwner(carCriteria: CarCriteria): Observable<any>{ 
      
    //return this.http.get<any>(AppUrl.carPark+"/for-owner", httpOptions );

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let params = new HttpParams();
    params = carCriteria.getHttpParams();

    return this.http.get<any>(
      AppUrl.carPark+"/cars", 
      {headers, params} 
    ); 
  
  }

  getMyCarsForProvider(): Observable<any>{ 
      
    return this.http.get<any>(AppUrl.carPark+"/for-provider", httpOptions );
  
  }

  
  getCustomerCars(businessLine: CarBusinessLine, favoritesOnly: boolean): Observable<any>{ 
    
    if(favoritesOnly)
      return this.http.get<any>(AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/search/my-favorites", httpOptions );
    else
      return this.http.get<any>(AppUrl.apiBaseURL+"/"+businessLine.toString().toLowerCase()+"/search/customer", httpOptions );
  }

  getProviderCars(bizLine: CarBusinessLine): Observable<any>{ 
    
    return this.http.get<any>(AppUrl.apiBaseURL+"/"+bizLine.toString().toLowerCase()+"/search/provider", httpOptions );

  }

  getAdminCarBasket(bizLine: CarBusinessLine): Observable<any>{ 
      
    return this.http.get<any>(AppUrl.apiBaseURL+"/"+bizLine.toString().toLowerCase()+"/search/admin-basket", httpOptions );
  
  }
/*
  getMyFavCars(carIds: string[] ): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.allMyFavCars, 
      carIds, 
      httpOptions );
  
  }
*/
  getAllCars(): Observable<any>{ 
      
    return this.http.get<any>(AppUrl.allCars, httpOptions );
    
  }

  createNewPrice(carId: string, businessLine: CarBusinessLine, price: Price): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carDetails+"/"+carId+"/price/new/"+businessLine.toString(), 
        price, 
        httpOptions );
  }

  updateCarDetails(carUpd: Car): Observable<any>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;

    //let credentials: LoginCredentials = new LoginCredentials (username, password);
      
    //return this.http.post<any>(AppUrl.carDetails+"/new", {make: car.make, model: car.model, variant: car.variant, bodyType: car.bodyType, firstRegistration: 2021}, httpOptions );
    return this.http.post<any>(
      AppUrl.carDetails+"/"+carUpd.carId, 
      AppFunctions.removeEmpty(carUpd), 
      httpOptions );
  }

  deleteCar(carId: string): Observable<any>{ 
    return this.http.delete<any>(
      AppUrl.carDetails+"/"+carId, 
      httpOptions );
  }

  toggleCarFavoriteOld(carId: string, makeFav: boolean, businessLine: CarBusinessLine): Observable<StringData>{ 

    let favUrl: string = "";

    switch(businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        favUrl = AppUrl.buyCustomerData+"/favorites";
        break;
      }
      case CarBusinessLine.RENT.toString():{
        favUrl = AppUrl.rentCustomerData+"/favorites";
        break;
      }
      
      default:{
        return of();
        break;
      }
    }
      
    if(makeFav){ 
      return this.http.post<any>(
        favUrl+"/add", 
        carId, 
        httpOptions );
    }
    else {
      return this.http.post<any>(
        favUrl+"/remove", 
        carId,
        httpOptions 
        );
    }  
  }

  toggleFavorite(objectId: string, objectClass: ObjectClass, makeFav: boolean, businessLine: CarBusinessLine): Observable<StringData>{ 

    let data = {objectId: objectId, objectClass: objectClass, makeFavorite: makeFav}

    switch(businessLine!.toString()){

      case CarBusinessLine.BUY.toString():{

        return this.http.post<any>(
          AppUrl.buyCustomerData+"/favorites-toggle",
          {objectId: objectId, objectClass: objectClass, makeFavorite: makeFav}, 
          httpOptions 
        );
      }

      case CarBusinessLine.RENT.toString():{

         return this.http.post<any>(
          AppUrl.rentCustomerData+"/favorites-toggle",
          {objectId: objectId, objectClass: objectClass, makeFavorite: makeFav}, 
          httpOptions 
        );
      }
      
      default:{
        return of();
      }
    } 
  }

  toggleCarBusinessLineStatus(carId: string, status: boolean, businessLine: CarBusinessLine): Observable<StringData>{ 
      
    //return of(status);
    if(status){ 
      return this.http.post<any>(
        AppUrl.carBusinessLine+"/"+businessLine+"/add", 
        {data: carId}, 
        httpOptions );
    }
    else {
      return this.http.post<any>(
        AppUrl.carBusinessLine+"/"+businessLine+"/remove", 
        {data: carId}, 
        httpOptions );
    }  
  }

  updateCarStatus(carId: string, status: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carDetails+"/"+carId+"/update-status", 
      {data: status},
      httpOptions );
     
  }

  updateCarProvider(carId: string, providerId: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carDetails+"/"+carId+"/update-provider", 
      providerId,
      httpOptions );
  }

  updateCarProviderActiveStatus(carId: string, status: boolean): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.carDetails+"/"+carId+"/update-provider-status", 
      status,
      httpOptions );
  }

  private getCustomerDataBaseUrl(businessLine: CarBusinessLine): string{

    let favUrl: string = "";

    switch(businessLine!.toString()){

      case CarBusinessLine.BUY.toString():{
        favUrl = AppUrl.buyCustomerData;
        break;
      }

      case CarBusinessLine.RENT.toString():{
        favUrl = AppUrl.rentCustomerData;
        break;
      }

      case CarBusinessLine.KEEP.toString():{
        favUrl = AppUrl.keepCustomerData;
        break;
      }
      
      default:{
       return "";
        break;
      }
    }

    return favUrl;

  }

  addNewAlert(crt: CarCriteria | DealerCriteria | JobCriteria): Observable<any>{ 

    return this.http.post<any>(
      this.getCustomerDataBaseUrl(crt.businessLine!)+"/alerts/new", 
        crt, 
        httpOptions );
  }

  updateAlertCriteria(alertId: number, crt: CarCriteria): Observable<any>{ 
     
    return this.http.post<any>(
      this.getCustomerDataBaseUrl(crt.businessLine!) +"/alerts/"+alertId+"/update", 
      crt,
      httpOptions );
     
  }

  deleteAlert(businessLine: CarBusinessLine, alertId: number): Observable<any>{ 

    return this.http.post<any>(
      this.getCustomerDataBaseUrl(businessLine) +"/alerts/"+alertId+"/delete", 
      httpOptions );
  }

  updateAlertStatus(businessLine: CarBusinessLine, alertId: number, status: boolean): Observable<any>{ 
    
    return this.http.post<any>(
      this.getCustomerDataBaseUrl(businessLine) +"/alerts/"+alertId+"/update-status", 
      status,
      httpOptions );
     
  }

  fetchMyAlerts(businessLine: CarBusinessLine): Observable<any>{ 
    return this.http.get<any>(
      this.getCustomerDataBaseUrl(businessLine) +"/alerts/my", 
      httpOptions 
    );
  }

  sendNewMessage(message: Message ): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.conversations+"/message/new", 
        message, 
        httpOptions );
  }

  replyMessage(reply: string, conversationId: number): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.conversations+"/"+conversationId+"/reply", 
        {data: reply}, 
        httpOptions );
  }

  fetchSentMessages(): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.conversations+"/sent", 
        httpOptions );
  }

  fetchReceivedMessages(): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.conversations+"/received", 
        httpOptions );
  }

  // review

  // addNewRating(rate: number, sellerId: string): Observable<any>{ 
      
  //   return this.http.post<any>(
  //     AppUrl.dealerReviews+"/new", 
  //     {rate: rate, raterId: sellerId},
  //     httpOptions );
     
  // }

  addNewReview(review: Review): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerReviews+"/new", 
      review,
      httpOptions );
  }

  updateReviewStatus(reviewId: string, status: ReviewStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerReviews+"/"+reviewId+"/update-status", 
      status,
      httpOptions );
  }

  replyReview(reviewId: string, reply: ReviewReply): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerReviews+"/"+reviewId+"/replies/new", 
      reply,
      httpOptions ); 
  }

  updateReviewReplyStatus(reviewId: string, replyIndex: number, status: ReviewStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerReviews+"/"+reviewId+"/replies/"+replyIndex+"/update-status", 
      status,
      httpOptions );
  }

  // contract

  contractAddNew(contract: Contract): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/new", 
      contract,
      httpOptions );
  }

  contractUpdate(contract: Contract): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contract.contractId+"/update", 
      contract,
      httpOptions );
  }

  contractDelete(contractId: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contractId+"/delete", 
      contractId,
      httpOptions );
  }

  contractModificationSubmit(contractId: string, request: ContractModification): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contractId+"/modification-submit", 
      request,
      httpOptions );
  }

  contractModificationUpdate(contractId: string, request: ContractModification): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contractId+"/modification-update", 
      request,
      httpOptions );
  }

  contractModificationWithdraw(contractId: string, modificationId: number): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contractId+"/modification-withdraw/"+modificationId, 
      httpOptions );
  }

  contractModificationAnswer(contractId: string, modificationId: number, accepted: boolean): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.dealerContracts+"/"+contractId+"/modification-answer/"+modificationId, 
      accepted,
      httpOptions );
  }

  contractGetMyForOwner(): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.dealerContracts+"/for-owner/my", 
        httpOptions );
  }

  contractGetForOwner(ownerId: string): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.dealerContracts+"/for-owner/"+ownerId, 
        httpOptions );
  }

  contractGetMyForProvider(): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.dealerContracts+"/for-provider/my", 
        httpOptions );
  }

  contractGetForProvider(providerId: string): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.dealerContracts+"/for-provider/"+providerId, 
        httpOptions );
  }

  contractGetAllMy(): Observable<any>{ 
    return this.http.get<any>(
        AppUrl.dealerContracts+"/allmy", 
        httpOptions );
  }


  // Menu

  menuGetAllMy(codes: MenuCode[]): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params: HttpParams = new HttpParams().append('menuCodes', codes.join(', '))

    return this.http.get<any>(
      //AppUrl.dealerMenu,
      AppUrl.buyMenu,
      {headers, params} 
    );
  }

  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}



      
    //return this.http.get<any>(AppUrl.search+"/similar", {headers, params} );

    //console.log(params)

  